module.exports = __webpack_public_path__ + "static/landing-bckg-0de5f51bbb4af17505057f21a7cd4f44.jpg";